<template>
  <v-container class="mx-auto mt-15">
    <v-row v-if="fetchAllWords">
      <v-col lg="3" sm="6" v-for="value in data.slice(0, 8)" :key="value.id">
        <div>
          <div class="img-area">
            <router-link :to="`/sigorta-sozlugu/${value.screenId}`">
              <v-img
                v-if="value.document"
                width="275px"
                height="275px"
                class="image"
                :src="`data:image/jpeg;base64,${value.document.fileContent}`"
                :alt="value.title"
                :title="value.title"
              ></v-img>
              <v-img
                v-else
                width="275px"
                height="275px"
                class="image"
                src="@/assets/temp/dictionary-img.svg"
                :alt="value.title"
                :title="value.title"
              ></v-img>
              <div class="overlay">
                <div class="text">{{ value.keyWord }}</div>
              </div>
            </router-link>
          </div>
          <div class="img-title">
            <router-link
              :to="`/sigorta-sozlugu/${value.screenId}`"
              class="text-decoration-none"
            >
              <h2>{{ value.keyWord }}</h2>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
        <v-row v-else>
      <v-col lg="3" sm="6" v-for="letter in filteredLetter.slice(0, 8)" :key="letter.id">
        <div>
          <div class="img-area">
            <router-link :to="`/sigorta-sozlugu/${letter.screenId}`">
              <v-img
                v-if="letter.document"
                width="275px"
                height="275px"
                class="image"
                :src="`data:image/jpeg;base64,${letter.document.fileContent}`"
                :alt="letter.title"
                :title="letter.title"
              ></v-img>
              <v-img
                v-else
                width="275px"
                height="275px"
                class="image"
                src="@/assets/temp/dictionary-img.svg"
                :alt="letter.title"
                :title="letter.title"
              ></v-img>
              <div class="overlay">
                <div class="text">{{ letter.keyWord }}</div>
              </div>
            </router-link>
          </div>
          <div class="img-title">
            <router-link
              :to="`/sigorta-sozlugu/${letter.screenId}`"
              class="text-decoration-none"
            >
              <h2>{{ letter.keyWord }}</h2>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
    <curiosities-section
      :data="data"
      :API_BASE_URL="API_BASE_URL"
      class="mb-5"
    />
    <v-row v-if="fetchAllWords">
      <v-col lg="3" sm="6" v-for="value in data.slice(8, 16)" :key="value.id">
        <div>
          <div class="img-area">
            <router-link :to="`/sigorta-sozlugu/${value.screenId}`">
              <v-img
                v-if="value.document"
                width="275px"
                height="275px"
                class="image"
                :src="`data:image/jpeg;base64,${value.document.fileContent}`"
                :alt="value.title"
                :title="value.title"
              ></v-img>
              <v-img
                v-else
                width="275px"
                height="275px"
                class="image"
                src="@/assets/temp/dictionary-img.svg"
                :alt="value.title"
                :title="value.title"
              ></v-img>
              <div class="overlay">
                <div class="text">{{ value.keyWord }}</div>
              </div>
            </router-link>
          </div>
          <div class="img-title">
            <router-link
              :to="`/sigorta-sozlugu/${value.screenId}`"
              class="text-decoration-none"
            >
              <h2>{{ value.keyWord }}</h2>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
     <v-row v-else>
      <v-col lg="3" sm="6" v-for="letter in filteredLetter.slice(8, 16)" :key="letter.id">
        <div>
          <div class="img-area">
            <router-link :to="`/sigorta-sozlugu/${letter.screenId}`">
              <v-img
                v-if="letter.document"
                width="275px"
                height="275px"
                class="image"
                :src="`data:image/jpeg;base64,${letter.document.fileContent}`"
                :alt="letter.title"
                :title="letter.title"
              ></v-img>
              <v-img
                v-else
                width="275px"
                height="275px"
                class="image"
                src="@/assets/temp/dictionary-img.svg"
                :alt="letter.title"
                :title="letter.title"
              ></v-img>
              <div class="overlay">
                <div class="text">{{ letter.keyWord }}</div>
              </div>
            </router-link>
          </div>
          <div class="img-title">
            <router-link
              :to="`/sigorta-sozlugu/${letter.screenId}`"
              class="text-decoration-none"
            >
              <h2>{{ letter.keyWord }}</h2>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CuriositiesSection from "@/views/dictionary/CuriositiesSection"

export default {
  components: {
    CuriositiesSection
  },
  props: ["data", "API_BASE_URL", "fetchAllWords", "filteredLetter"]
}
</script>
